const debug = process.env.REACT_APP_DEBUG && false;
export const getDefaultObjectToRowFn = (allKeys) => (object) => ({
    columnIndexedKeys: allKeys,
    row: allKeys.map((k) => {
        if (typeof object[k] === 'object') {
            return object[k] === null ? '' : JSON.stringify(object[k]);
        }
        else {
            return object[k];
        }
    }),
});
export const defaultRowToObject = (colKeys, row, rowIndex) => {
    const fallbackId = rowIndex.toString();
    const fallbackType = 'Unknown';
    const colKeyRowMapper = getColKeysRowMapperFn(colKeys);
    /** retain nulls, dont include undefineds */
    const entries = colKeyRowMapper(row).filter(([k, v]) => v === null || v === false || v === 0 || !!v);
    debug && console.log('ordered entires', entries);
    const parsedEntries = Object.fromEntries(entries);
    const object = { id: fallbackId, type: fallbackType, ...parsedEntries };
    return object;
};
const preferredKeyOrder = ['timestamp', 'time', 'name', 'type'];
/** orders entries */
export const defaultEntrySorter = ([k1], [k2]) => defaultKeySorter(k1, k2);
/** orders key */
export const defaultKeySorter = (k1, k2) => {
    let sort = k1 < k2 ? -1 : 1;
    const k1Pref = preferredKeyOrder.findIndex((x) => x === k1);
    const k2Pref = preferredKeyOrder.findIndex((x) => x === k2);
    if (k1Pref !== -1 || k2Pref !== -1) {
        sort = k2Pref === -1 ? -1 : k1Pref === -1 ? 1 : k1Pref < k2Pref ? -1 : 1;
    }
    console.log(`sorted ${k1} ${k2} as`, sort);
    return sort;
};
/** returns array of [k,v] to be used in Object.entries of defautRowToObject
 * could be extended to support dot notation in headers?
 */
const getColKeysRowMapperFn = (colKeys) => (row) => colKeys.map((k, i) => {
    let v = row[i];
    /** treat 'null' as null */
    if (v === 'null')
        v = null;
    /** detect and deal with JSON */
    if (typeof v === 'string') {
        if (v.match(/^("|\[|{).*?("|\]|})$/)) {
            try {
                v = JSON.parse(v);
            }
            catch (e) {
                v = 'unparsible JSON';
            }
        }
    }
    return [k, v];
});
export const commonObjectTypeToVOB = (cot) => {
    const { type, id } = cot;
    const key = `${type}:${id}`;
    return { pk: key, sk: key, ...cot };
};
